<template>
  <div>
    <!-- <div class="satisfaction">
      <span>商品满意度</span>
      <div class="evaluateLevel" style="margin-left:30px">
        <div class="item" style="background:#fad7d8;">
          1
        </div>
        <p>非常差</p>
      </div>
      <div class="evaluateLevel">
        <div class="item" style="background:#f4b0b1">
          2
        </div>
        <p>差</p>
      </div>
      <div class="evaluateLevel">
        <div class="item" style="background:#ef888a">
          3
        </div>
        <p>一般</p>
      </div>
      <div class="evaluateLevel">
        <div class="item" style="background:#e96163">
          4
        </div>
        <p>好</p>
      </div>
      <div class="evaluateLevel">
        <div class="item" style="background:#e4393c">
          5
        </div>
        <p>非常好</p>
      </div>
    </div> -->
    <div class="appraise-title">
      <span>{{
        $t('PointsMall.AllEvaluations') + '(' + (evaluateList.length || 0) + ')'
      }}</span>
      <!-- <span>时间</span> -->
    </div>
    <div style="margin-top: 20px">
      <!-- <img style="display:inline-block" src="http://www.0elem.com/resource/public/images/null.png"> -->
      <div v-if="evaluateList && evaluateList.length" class="evaluate-wrap">
        <div
          v-for="(item, index) in evaluateList"
          :key="index"
          class="evaluate-item"
        >
          <div class="user-name">
            <span style="font-weight: 600">{{ item.CustomerName }}</span>
            <el-rate :value="item.EvaluationLevel"></el-rate>
          </div>
          <div class="pro-info">
            <span>{{ item.CreateDT }}</span>
            <span>{{ item.ProductName }}</span>
            <span>{{ item.ProductSpecifications }}</span>
          </div>
          <div class="remark-content">{{ item.EvaluationContent }}</div>
          <el-divider></el-divider>
        </div>
      </div>
      <p v-else style="text-align: center">
        {{ $t('PointsMall.NoEvaluation') }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    evaluateList: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  data() {
    return {

    }
  }
}
</script>
<style lang="less" scoped>
.satisfaction {
  width: 100%;
  display: flex;
  justify-content: left;
  padding: 50px;
}
.evaluateLevel {
  width: 100px;
  text-align: center;
}
.item {
  height: 20px;
  text-align: center;
  color: white;
}
.appraise-title {
  height: 36px;
  line-height: 36px;
  width: 100%;
  right: 20px;
  background-color: #f8f8f8;
  display: flex;
  justify-content: space-between;
  padding: 0px 30px;
}
.evaluate-wrap {
  .evaluate-item {
    margin-top: 10px;
    padding-left: 10px;
    .user-name {
      display: flex;
      justify-content: space-between;
    }
    .pro-info {
      color: #959292;
      font-size: 12px;
      span {
        margin-right: 10px;
      }
    }
    .remark-content {
      margin-top: 4px;
      color: #444342;
    }
  }
  .el-divider--horizontal {
    margin: 15px 0;
  }
}
</style>
